<div class="sh-form-row-with-action">
  <div class="sh-form-row-with-action__inputs">
    <div class="sh-form-row-with-action__inputs__item">
      <sh-advanced-search-row-include
        [id]="id + '-include'"
        [i18n]="i18n"
        [label]="i18n.includeExclude.label"
        [isHeader]="index === 0"
        [control]="operandControl"
      ></sh-advanced-search-row-include>
    </div>
    <div class="sh-form-row-with-action__inputs__item">
      <sh-advanced-search-row-field
        [id]="id + '-field'"
        [i18n]="i18n"
        [label]="i18n.type.label"
        [isHeader]="index === 0"
        [control]="fieldControl"
        [options]="formSelectOptions$ | async"
        [profileFields]="profileFields$ | async"
        [searchPlaceholder]="i18n.search.placeholder"
      ></sh-advanced-search-row-field>
    </div>
    <div class="sh-form-row-with-action__inputs__item">
      <sh-advanced-search-row-value
        class="sh-form-group"
        [id]="id + '-value'"
        [i18n]="i18n"
        [label]="i18n.value.label"
        [isHeader]="index === 0"
        [profileField]="selectedProfileField$ | async"
        [control]="valueControl"
        [fieldDefinitionOptions]="valueFormSelectOptions$ | async"
        [searchPlaceholder]="i18n.search.placeholder"
        (searchChanges)="onValueSearchChanged($event)"
      ></sh-advanced-search-row-value>
    </div>
  </div>
  <div class="sh-form-row-with-action__actions">
    @for (item of (actionItems$ | async); track item) {
      <sh-action-item [item]="item" class="sh-form-row-with-action__actions__item"></sh-action-item>
    }
  </div>
</div>
